import { isAddBasketOfferPurchaseEvent } from '@ori-events/add-basket-offer';
import { RequestUrl } from '../types';
import { addBasketOffer } from '../utils';
export async function addBasketOfferHandler(event) {
  if (isAddBasketOfferPurchaseEvent(event)) {
    const {
      detail: {
        items,
        offerId: choiceId,
        placement
      }
    } = event;
    return addBasketOffer(RequestUrl.PurchaseBasketOffer, {
      choiceId,
      items,
      placement
    });
  }
  const {
    detail: {
      offerId,
      placement
    }
  } = event;
  return addBasketOffer(RequestUrl.AddBasketOffer, {
    offerId,
    placement
  });
}
//# sourceMappingURL=addBasketOfferHandler.js.map